import createBoardSlice from './createBoardSlice';
import { MAT_CONFIGS, MAT_COORDS_NAME } from './matConfigs';

const config = MAT_CONFIGS[MAT_COORDS_NAME];
const [cols, rows] = config.gridSize;

export const matCoordsSlice = createBoardSlice({
    name: MAT_COORDS_NAME,
    defaultInitialState: [...new Array(rows).fill([...new Array(cols).fill(0)])],
});

export const { actions, selectors } = matCoordsSlice;

export default matCoordsSlice.reducer;
